import React, { useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { envs } from "../../../config";
import JsonDataContainer from "./JsonData.Style";

const JsonData = (props) => {
  const { disabledView, className, position } = props;

  const data = useMemo(
    () => ({
      ...props,
      children: undefined,
      className: undefined,
      disabledView: undefined,
      position: undefined,
    }),
    [props]
  );

  useEffect(() => {
    // eslint-disable-next-line no-console
    console.log(data);
  }, [data]);

  return envs.enableDebugData && !disabledView ? (
    <JsonDataContainer position={position} className={className}>
      <div>
        <code>
          <pre>
            {JSON.stringify(
              {
                ...data,
              },
              null,
              4
            )}
          </pre>
        </code>
      </div>
    </JsonDataContainer>
  ) : null;
};

JsonData.propTypes = {
  disabledView: PropTypes.bool,
  position: PropTypes.string,
};

JsonData.defaultProps = {
  disabledView: false,
  position: "right",
};

export default JsonData;
